import React from 'react';
import Checkbox from '@nib-components/checkbox';
import BaseFormField from '../base-form-field';
const ConfirmationCheckbox = _ref => {
  let {
    label,
    fieldLabel,
    checked,
    required,
    ...otherProps
  } = _ref;
  return React.createElement(BaseFormField, {
    ...otherProps,
    label: fieldLabel,
    required: required
  }, React.createElement(Checkbox, {
    checked: checked,
    label: label
  }));
};
export default ConfirmationCheckbox;